module.exports = __webpack_public_path__ + "static/media/clouds.f4924c21.svg";